export class Shutter {
    constructor(objectId: string, name: string, type: ShutterType, online: boolean, lastComm: Date) {
        this.objectId = objectId;
        this.name = name;
        this.type = type;
        this.online = online;
        this.lastComm = lastComm;
    }

    objectId: string;//objectId ElementParse
    name: string;
    type: ShutterType;
    status?: ShutterStatus;
    level?: number;
    online: boolean;
    lastComm: Date;

    public static build(shutter: Shutter): Shutter {
        let s = new Shutter(shutter.objectId, shutter.name, shutter.type, shutter.online, shutter.lastComm);
        s.status = shutter.status;
        s.level = shutter.level;
        return s;
    }
    public static fromJSON(json: any): Shutter {
        const s = new Shutter(
            json.objectId,
            json.name,
            json.type,
            json.online,
            json.lastComm ? new Date(json.lastComm) : new Date()
        );
        s.status = json.status;
        s.level = json.level;
        return s;
    }
}

export enum ShutterStatus {
    DOWN,
    UP
}

export enum ShutterType {
    BINARY,
    RANGE
}